import CloseIcon from '@/assets/icons/close.svg?react';
import { ComponentPropsWithoutRef, FC } from 'react';
import { twMerge } from 'tailwind-merge';

type CloseModalButtonProps = ComponentPropsWithoutRef<'button'>;

export const CloseModalButton: FC<CloseModalButtonProps> = ({ className, ...rest }) => (
  <button
    {...rest}
    className={twMerge(
      'absolute right-[1.375rem] top-[1.375rem] z-20 text-quaternary-400 rounded-lg',
      'focus:shadow-none focus:outline-none focus:ring-2 focus:ring-brand-600 focus:ring-offset-2',
      className
    )}
  >
    <CloseIcon />
  </button>
);
